import { render, staticRenderFns } from "./ValuesList.vue?vue&type=template&id=450aaf94"
import script from "./ValuesList.vue?vue&type=script&lang=js"
export * from "./ValuesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports